export default __webpack_public_path__ + "static/media/ordinacija-Office_W629-C-CLEANEO-obloga-CW.d5dbc2ff.jpg";